import type { SxProps, Theme } from '@mui/material/styles'

/** Figma `1:1047` — card kebab dropdown shell. */
export const sensemakerCardMenuPaperSx: SxProps<Theme> = {
  mt: 0.5,
  borderRadius: '10px',
  border: '0.5px solid #e0e5eb',
  bgcolor: '#ffffff',
  boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
  minWidth: 157,
  overflow: 'hidden',
  '& .MuiList-root': {
    py: 0,
  },
}

/** Figma `1:1048` — destructive menu action label. */
export const sensemakerCardDeactivateMenuItemSx: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '-0.1504px',
  color: '#ef4444',
  minHeight: 31,
  px: '20px',
  py: '6px',
  justifyContent: 'flex-start',
  '&:hover': {
    bgcolor: '#f8fafc',
  },
}

/** Story US-SML-1-18 — reactivate menu item (green text, same shell). */
export const sensemakerCardReactivateMenuItemSx: SxProps<Theme> = {
  ...sensemakerCardDeactivateMenuItemSx,
  color: '#008236',
}
